import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import SortBy from '../../SortBy/SortBy';
import HeaderFilters from '../HeaderFilters';
import style from '../ProductGridHeader.module.scss';

const DesktopCategoryGridHeader = ({
  categoryName,
  categoryResultsCount = null,
  categoryTitle = '',
  facet = [],
  onFacetTagClick = () => {},
  onSortChange = () => {},
  selectedSort = '',
  sortData = {
    sortOptions: [],
  },
}) => (
  <div
    className={classNames(
      style.productGridHeader, style.productGridHeaderDesktop, style.categoryGridHeader,
    )}
    data-testid="category-grid-header-desktop"
  >
    <div className={style.categoryHeadingWrapperDesktop}>
      <h1 className={`h3 ${style.categoryHeadingDesktop}`}>{categoryTitle || categoryName}</h1>
      {categoryResultsCount}
    </div>
    <HeaderFilters facet={facet} onFacetTagClick={onFacetTagClick} />
    <div className={style.lastColumn} data-testid="sort-by-desktop">
      {sortData.sortOptions?.length !== 0 ? (
        <SortBy onSortChange={onSortChange} selectedSort={selectedSort} sortData={sortData} />
      ) : null}
    </div>
  </div>
);

DesktopCategoryGridHeader.propTypes = {
  categoryName: PropTypes.string.isRequired,
  categoryTitle: PropTypes.string,
  categoryResultsCount: PropTypes.node,
  facet: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),
  onFacetTagClick: PropTypes.func,
  onSortChange: PropTypes.func,
  selectedSort: PropTypes.string,
  sortData: PropTypes.shape({
    sortOptions: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        value: PropTypes.string,
      }),
    ),
  }),
};

export default DesktopCategoryGridHeader;
